import { ref as m, computed as f, onMounted as H, onBeforeUnmount as q, watch as F, resolveComponent as J, openBlock as v, createElementBlock as T, createElementVNode as k, renderSlot as B, createTextVNode as g, normalizeClass as Q, createCommentVNode as x, createBlock as U, withModifiers as W, nextTick as _ } from "vue";
import { onClickOutside as j } from "./design-system.es125.js";
/* empty css                    */
import A from "./design-system.es128.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import { bottomStart as a, rightStart as G, rightEnd as K, leftStart as X, leftEnd as Y, bottomEnd as E, topStart as b, topEnd as I } from "./design-system.es294.js";
import Z from "./design-system.es25.js";
import $ from "./design-system.es146.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import ee from "./design-system.es341.js";
import { distanceToBottomEdge as oe } from "./design-system.es140.js";
/* empty css                    */
import { createPopper as te } from "./design-system.es297.js";
const ne = {
  name: "DsDropdownLegacy",
  components: { TouchOverlay: ee },
  props: {
    /**
     * Controls the open state of the dropdown.  This makes the dropdown controlled and will not work with uncontrolled options.
     */
    isOpen: {
      type: Boolean,
      default: null
    },
    /**
     * Enables dense menu items
     */
    dense: Boolean,
    /**
     * Disable scroll on the dropdown list options
     */
    disableScroll: Boolean,
    /**
     * Sets the dropdown width to the available container width
     */
    dropdownBlock: Boolean,
    /**
     * Will the list items have icons, if so needs more padding
     */
    icons: Boolean,
    /**
     * Pin the bottom of the menu to the bottom of the viewport for really long menus
     */
    pinBottom: Boolean,
    /**
     * Position the dropdown either left aligned or right aligned below its reference
     */
    position: {
      type: String,
      default: a,
      options: [
        G,
        K,
        X,
        Y,
        a,
        E,
        b,
        I
      ]
    },
    /**
     * Keep inline instead of fixing to the bottom of the screen on small screens
     */
    smallInline: Boolean
  },
  emits: [
    "change",
    "close"
  ],
  setup(o, { emit: e, expose: s }) {
    const { isRtl: t, isTouchDevice: y } = $(), C = Z({ query: "(max-width: 767px)" }), r = m(!1), n = m(null), P = m(null), l = m(null), d = m(null), p = f(() => o.isOpen === !0 || o.isOpen === !1), M = f(() => t.value ? o.position === a ? E : o.position === b ? I : a : o.position), w = f(() => y.value && C.value && !o.smallInline);
    function c() {
      var i;
      (i = n.value) == null || i.update();
    }
    function z() {
      _(() => {
        if (l.value)
          if (r.value) {
            const i = oe(l.value, document, !0), N = window.parseFloat(getComputedStyle(document.documentElement).fontSize), V = `${i - 2 * N}px`;
            l.value.style.maxHeight = V;
          } else
            l.value.style.maxHeight = "100px";
      });
    }
    function h() {
      o.pinBottom && setTimeout(z, 10);
    }
    function u() {
      r.value && (r.value = !1, e("change", !1), e("close"), c(), h());
    }
    function O() {
      r.value = !0, e("change", !0), c(), h();
    }
    function D() {
      r.value ? u() : O();
    }
    function R() {
      p.value || u();
    }
    function L() {
      p.value || D();
    }
    function S() {
      if (p.value) {
        o.isOpen && setTimeout(() => {
          e("close");
        });
        return;
      }
      u();
    }
    return H(() => {
      w.value || (n.value = te(d.value, l.value, {
        placement: M.value,
        modifiers: [
          {
            name: "eventListeners",
            options: {
              scroll: !0,
              resize: !0
            }
          }
        ]
      }));
    }), q(() => {
      var i;
      (i = n.value) == null || i.destroy();
    }), F(() => o.isOpen, (i) => {
      i ? O() : u();
    }, { immediate: !0 }), j(
      l,
      S,
      { ignore: [d] }
    ), s({ schedulePopper: c }), {
      isOpenInternal: r,
      target: P,
      menu: l,
      reference: d,
      touch: w,
      schedulePopper: c,
      close: u,
      onMenuClick: R,
      onReferenceClick: L,
      onBodyClick: S
    };
  }
}, ie = { class: "menu" }, re = {
  key: 0,
  class: "footer"
};
function le(o, e, s, t, y, C) {
  const r = J("TouchOverlay");
  return v(), T("div", {
    class: "dropdown",
    onInput: e[2] || (e[2] = (...n) => t.schedulePopper && t.schedulePopper(...n))
  }, [
    k("div", {
      ref: "reference",
      class: "dropdown-reference",
      onClick: e[0] || (e[0] = (...n) => t.onReferenceClick && t.onReferenceClick(...n))
    }, [
      B(o.$slots, "default", {}, void 0, !0)
    ], 512),
    e[4] || (e[4] = g()),
    k("div", {
      ref: "menu",
      class: Q(["dropdown-menu", [{
        icons: s.icons,
        touch: t.touch,
        dense: s.dense,
        open: t.isOpenInternal,
        "dropdown-block": s.dropdownBlock,
        "disable-scroll": s.disableScroll
      }]]),
      onClick: e[1] || (e[1] = (...n) => t.onMenuClick && t.onMenuClick(...n))
    }, [
      k("div", ie, [
        B(o.$slots, "menu", {}, void 0, !0)
      ]),
      e[3] || (e[3] = g()),
      o.$slots.footer ? (v(), T("div", re, [
        B(o.$slots, "footer", { toggleable_close: t.close }, void 0, !0)
      ])) : x("", !0)
    ], 2),
    e[5] || (e[5] = g()),
    t.touch && t.isOpenInternal ? (v(), U(r, {
      key: 0,
      onClick: W(t.onBodyClick, ["prevent", "stop"])
    }, null, 8, ["onClick"])) : x("", !0)
  ], 32);
}
const Ge = /* @__PURE__ */ A(ne, [["render", le], ["__scopeId", "data-v-23088264"]]);
export {
  Ge as default
};
//# sourceMappingURL=design-system.es195.js.map
